import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import Box from "@mui/material/Box";
import Footer from "../../../components/Footer";
import * as acts from "../../../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../../../components/ProgressBar";
import "./newBatch.scss";
// import { notification } from "../../../constants/notificationMessages";
import constantValues from "../../../constants/constantValues";
import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  List,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import BulkBatchCheckBoxList from "../../../components/UploadBatchRecord/CheckboxTitle/BulkBatchList";
import constants from "../../../constants/constantValues";
import { format } from "date-fns";
import Label from "../../../components/Label/Label";
import DatePicker from "react-datepicker";
import Authentication from "../../../components/Modal/PopupModal/PopupModal";
import ModalSign from "../../../components/Modal/Signature/ModalSign";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import { preProRoutes } from "../../../routes/routeConstants";

const BulkBatchCreation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getUser = useSelector((state) => state?.prePro?.userList);
  const tags = useSelector((state) => state?.prePro?.tags);
  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const drugType = useSelector((state) => state?.prePro?.drugType);
  const signUploaded = useSelector(
    (state) => state?.prePro?.isSignatureUploaded
  );

  const fileType = "actual_pdfs";
  const { TIMELINE, SELECT, SUBMIT_PROCESSING } = constants;
  // const subject = notification.subjectPre;
  const { TEXT_EXTRACTION } = constantValues;

  const [message, setMessage] = useState("");
  const subFolder = localStorage.drugType;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [timeLineEndDate, setTimeLineEndDate] = useState(null);
  const [userName, setUserName] = useState("");
  const [openAuth, setOpenAuth] = useState(false);
  const [openSignPad, setOpenSignPad] = useState(false);
  // const remark = notification.remarkPre;
  const [err, setErr] = useState(false);
  const [success, setSuccess] = useState(false);
  const [checked, setChecked] = React.useState(true);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  useEffect(() => {
    dispatch(acts.getTags(localStorage.projectId));
    dispatch(acts.getS3Files(fileType, subFolder));
    dispatch(acts.getUserList());
    dispatch(acts.clearApiStatus());
    dispatch(acts.clearIsSignatureUploadedStatus());
    dispatch(acts.isSignatureUploaded());
    dispatch(acts.validateUserClear());
  }, []);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true) {
        setErr(true);
        setMessage(apiStatus?.message);
        dispatch(acts?.clearApiStatus());
      } else if (apiStatus?.apiSuccess === true && apiStatus?.next === true) {
        setSuccess(true);
        setMessage(apiStatus?.message);
        setTimeout(() => {
          navigate(`/${preProRoutes.preProDashboard}`)  
        }, 2000);
      }
    }
  }, [apiStatus]);

  const handleToggleCheckbox = (item) => {
    const currentIndex = selectedFiles.findIndex(
      (selectedItem) => selectedItem.file_name === item.file_name
    );
    const newSelectedFiles = [...selectedFiles];

    if (currentIndex === -1) {
      newSelectedFiles.push({
        ...item,
        tagName: tags?.data?.tags[0],
      });
    } else {
      newSelectedFiles.splice(currentIndex, 1);
    }

    setSelectedFiles(newSelectedFiles);

    setSelectAllChecked(false);
  };

  const onClick = (event, action) => {
    //Electronic signature
    dispatch(acts.isSignatureUploaded());
    if (action === "continue") {
      if (signUploaded?.isSignatureUploaded !== undefined) {
        if (signUploaded?.isSignatureUploaded === false) {
          setOpenSignPad(true);
        }
        if (signUploaded?.isSignatureUploaded === true) {
          setOpenAuth(true);
        }
      }
    }
  };

  const handleUserPermission = () => {
    //submitting batch for processing
    const renamedKeys = [];

    selectedFiles.map((item) => {
      renamedKeys.push({
        pdfpath: item?.file_url || "",
        original_filename: item?.file_name || "",
        tagname: item?.tagName || "",
      });
    });

    const bulkBatchData = {
      project_id: localStorage.projectId,
      files_paths: renamedKeys,
      processor: userName,
      timeline: format(timeLineEndDate, "yyyy-MM-dd"),
      auto_extraction: checked,
      subject: "New batch assigned for Processing.",
      remark: "I’m the Pre Processor",
    };

    dispatch(acts.bulkBatchCreation(bulkBatchData));
  };

  const handleEsignDialogBoxClose = () => {
    setOpenSignPad(false);

    setTimeout(() => {
      dispatch(acts.isSignatureUploaded());
    }, 1500);
  };

  const handleCheckBoxClick = (event) => {
    setChecked(event.target.checked);
  };

  const handleSelectAll = () => {
    //const currentIndex = groupData.indexOf(value);

    // const newDataArray = group?.map((item) => ({
    //   ...item,
    // }));
    // setGroupData(newDataArray);

    if (!selectAllChecked) {
      const newdata = [];

      drugType?.data?.map((item) => {
        newdata.push({ ...item, tagName: tags?.data?.tags[0] });
      });
      setSelectedFiles([...newdata]);
      setSelectAllChecked(true);
    } else if (selectAllChecked) {
      setSelectedFiles([]);
      setSelectAllChecked(false);
    }
  };

  return (
    <React.Fragment>
      <Header />
      <Box className="stepper-wrap">
        <Label text="Bulk Batches Creation" fontWeight="600" fontSize="16px" />
      </Box>

      <Grid container direction={"row"}>
        <Grid
          item
          md={6}
          style={{
            height: "calc(100vh - 144px)",
            overflowY: "scroll",
          }}
        >
          <Box
            style={{
              position: "sticky",
              top: "0",
              zIndex: "2",
              background: "#fff",
              paddingLeft: "30px",
            }}
          >
            {/* <Label
              text="Select Batch Records"
              fontWeight="500"
              fontSize="14px"
              padding="10px 10px 10px 40px"
            /> */}
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectAllChecked}
                    onChange={handleSelectAll}
                  />
                }
                label="Select All"
              />
            </FormGroup>
            {/* <Divider className="divider-editable" /> */}
          </Box>

          {drugType && drugType?.loader ? (
            <DashboardTableSkaleton />
          ) : drugType?.data?.length > 0 ? (
            <List className="check-box-style">
              {drugType?.data?.map((item, index) => {
                return (
                  <>
                    <BulkBatchCheckBoxList
                      key={index}
                      onClick={(e) => handleToggleCheckbox(e)}
                      item={item}
                      selectedFiles={selectedFiles}
                    />
                    <Divider variant="middle" />
                  </>
                );
              })}
            </List>
          ) : (
            drugType?.loader === false && (
              <div className="no-data">
                <Label
                  text="No Data Found"
                  fontSize="16"
                  fontWeight="600"
                  padding="20px"
                />
              </div>
            )
          )}
        </Grid>

        <Grid
          item
          md={6}
          style={{
            height: "calc(100vh - 144px)",
            overflowY: "scroll",
            backgroundColor: "#f7f7f7",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {/* ***************************************************************************** */}
          <Box className="batchProcessing">
            <Grid container className="h-center">
              <Grid item md={10}>
                <div className="input-wrap-title">
                  <Label
                    fontSize="16px"
                    fontWeight="500"
                    text={SUBMIT_PROCESSING}
                  ></Label>
                </div>
                <form action="" className="batch-processing-form">
                  <FormControl fullWidth>
                    <div className="input-wrap">
                      <label>{SELECT}</label>
                      <Select
                        className="field-style"
                        fullWidth
                        value={userName}
                        name={SELECT}
                        input={
                          <OutlinedInput
                            onChange={(event) =>
                              setUserName(event.target.value)
                            }
                          />
                        }
                      >
                        {getUser &&
                          getUser.all_processor &&
                          getUser.all_processor.length > 0 &&
                          getUser.all_processor.map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                      </Select>
                    </div>
                    <div className="input-wrap">
                      <label>{TIMELINE}</label>
                      <DatePicker
                        className="Date-picker"
                        variant="outlined"
                        onChange={(date) => setTimeLineEndDate(date)}
                        selected={timeLineEndDate}
                        minDate={new Date()}
                        showDisabledMonthNavigation
                      />
                    </div>

                    <div className="checkBox">
                      <Checkbox
                        checked={checked}
                        onChange={handleCheckBoxClick}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      {TEXT_EXTRACTION}
                    </div>
                  </FormControl>
                </form>
              </Grid>
            </Grid>

            {openAuth && (
              <Authentication
                openAuth={openAuth}
                handleClose={() => setOpenAuth(false)}
                handleUserPermission={handleUserPermission}
              />
            )}

            {openSignPad && (
              <ModalSign
                openSignPad={openSignPad}
                handleEsignDialogBoxClose={() =>
                  handleEsignDialogBoxClose(false)
                }
              ></ModalSign>
            )}
          </Box>
        </Grid>
      </Grid>

      <Footer
        isNextDisable={
          userName !== "" &&
          timeLineEndDate !== null &&
          selectedFiles.length > 0
            ? false
            : true
        }
        isSaveDisable={true}
        isPrevious={false}
        onHandleClick={(event, action) => onClick(event, action)}
      />

      {drugType && drugType?.loader ? <ProgressBar /> : ""}

      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )}

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </React.Fragment>
  );
};
export default BulkBatchCreation;
